<!--
  样式上要注意，
  1. 这里的 transparent img 外层 必须有 div wrapper 元素，否则 object-fit: cover 配合 diplay:flex-row 的样式会失效，图片会还原为 640 x 640 像素展示。
  2. slot 的内部将会完全被 el-image 替换，el-image 已经考虑到了 div wrapper、object-fit、width/height 等一切因数。
-->
<template>
    <div class="reactive-row list-row">
        <!--备注，之前 slot 中的默认图片被我删除过，记住，不要删除，很重要，当浏览到最后一行的时候，如果不足三个，用下面的 placeholder 补齐-->
        <slot name="0"><div class="slot-img-wrapper margin-right margin-bottom"><img :src="require('@/assets/transparent.png')" style="border:0px solid black;" class="slot-img"/></div></slot>
        <slot name="1"><div class="slot-img-wrapper margin-right margin-bottom"><img :src="require('@/assets/transparent.png')" style="border:0px solid black;" class="slot-img"/></div></slot>
        <slot name="2"><div class="slot-img-wrapper margin-bottom"><img :src="require('@/assets/transparent.png')" style="border:0px solid black;" class="slot-img"></img></div></slot>
    </div>
</template>

<script>
    export default {
        name: "ListRow",
        methods: {
            /**
             * @param {Number} i, index of the slot
             * @return {String} slotname
             */
            getSlotName(i){
                switch (i) {
                    case 0:
                        return 'left';
                    case 1:
                        return 'center';
                    case 2:
                        return 'right';
                }
            }
        }
    }

</script>

<style>

    .list-row .slot-img-wrapper{
        width:100%;
        height:100%
    }

    .list-row .slot-img{
        width: 100%;
        height:100%;
        object-fit: cover;
    }

    .margin-right {
        margin-right: 1px;
    }

    .margin-bottom{
        margin-bottom: 1px;
    }

    /* @media 中的 .el-image-self 会覆盖前面的 .el-image-self */
    @media (min-width: 736px){
        .margin-right {
            margin-right: 28px;
        }

        .margin-bottom{
            margin-bottom: 28px;
        }
    }

    /*@media (min-width: 975px) {*/
    /*    .margin {*/
    /*        margin-right: 28px;*/
    /*        margin-bottom: 28px;*/
    /*    }*/
    /*}*/

</style>



// WEBPACK FOOTER //
// src/components/list/ListRow.vue